import RequestAbstract from "../abstract";

export default class PublicCurrentCurrencyRates extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-current-currency-rates";
    }

}
